import React, { useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from "react-router-dom";
import NavAction from '@visa/vds/nav-action';
import NavActionInfo from '@visa/vds/nav-action-info';
import Search from '@visa/vds/search';
import Input from '@visa/vds/input';
import InputOption from '@visa/vds/input-option';
import Icon from '@visa/vds/icon';
import ButtonIcon from '@visa/vds/button-icon';
import { SEARCH_PAGE } from '../_constants/PageRoutes';

const MCSSearchBar = (props) => {
    const location = useLocation();
    const persistentSearchRef = useRef();
    const [persistentSearchVal, setPersistentSearchVal] = useState('');
    const history = useHistory();

    const handleSearchValChange = (value) => {
        setPersistentSearchVal(value);
    }

    const handleSearch = (event) => {
        setPersistentSearchVal(event.target.value);
        if (event.key === "Enter" && persistentSearchVal.trim() !== "") {
            history.push({
                pathname: SEARCH_PAGE,
                search: '?q=' + encodeURIComponent(event.target.value)
            })
        }
    };

    useEffect(() => {
        if (location.pathname !== SEARCH_PAGE) {
            setPersistentSearchVal('');
        }
    }, [location]);

    return (
        <NavAction>
            <NavActionInfo>
                <Search aria-label="VSS Search Library" navbar>
                    <Input
                        contentBeforeInput={
                            <InputOption>
                                <Icon name="search" resolution="low" />
                            </InputOption>
                        }
                        aria-label="Site-wide"
                        onChange={e => handleSearchValChange(e.target.value)}
                        name="search_bar_input"
                        placeholder="Search Library"
                        type="search"
                        useNativePlaceholder
                        ref={persistentSearchRef}
                        value={persistentSearchVal}
                        onKeyPress={handleSearch}
                    >
                        {persistentSearchVal && persistentSearchVal.length ? 
                            <InputOption>
                                <ButtonIcon
                                    ariaLabel="clear"
                                    iconType="light-tiny"
                                    onClick={() => {
                                        // @ts-ignore
                                        persistentSearchRef.current.focus();
                                        setTimeout(() => {
                                            handleSearchValChange('');
                                        });
                                    }}
                                >
                                    <Icon name="clear" resolution="tiny" />
                                </ButtonIcon>
                            </InputOption>
                         : <></>}
                    </Input>
                </Search>
            </NavActionInfo>
        </NavAction>
    );
}
export default MCSSearchBar;